
  import { css } from 'lit';
  export const styles = css`:host{--message-color: var(--ig-dialog-message-color, var(--ig-gray-500));--ig-theme-variant: dark}`;
  